module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "lhsx"
  }, [_c('img', {
    staticClass: "positionSion",
    attrs: {
      "src": require("./dhqhLogo.png"),
      "width": "25%",
      "height": "20%",
      "alt": ""
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "positionSionTwo",
    attrs: {
      "src": require("./title.png"),
      "width": "80%",
      "height": "40%",
      "alt": ""
    }
  }), _vm._v(" "), (!_vm.showSuccess) ? _c('form', {
    attrs: {
      "id": "form",
      "method": "post",
      "onsubmit": "return false",
      "action": "##"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formData.clientName),
      expression: "formData.clientName"
    }],
    staticClass: "name",
    attrs: {
      "type": "text",
      "placeholder": "请输入真实姓名",
      "id": "inputEmail3"
    },
    domProps: {
      "value": (_vm.formData.clientName)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.formData.clientName = $event.target.value
      }, function($event) {
        _vm.formData.clientName = _vm.formData.clientName.replace(
          /[^\u4E00-\u9FA5]/g,
          ''
        )
      }]
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formData.clientMobile),
      expression: "formData.clientMobile"
    }],
    staticClass: "clientMobile",
    attrs: {
      "type": "number",
      "placeholder": "请输入手机号码"
    },
    domProps: {
      "value": (_vm.formData.clientMobile)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.formData.clientMobile = $event.target.value
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formData.code),
      expression: "formData.code"
    }],
    staticClass: "code",
    attrs: {
      "type": "text",
      "placeholder": "请输入验证码"
    },
    domProps: {
      "value": (_vm.formData.code)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.formData.code = $event.target.value
      }
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "send",
    class: {
      disable: this.verifyMsg !== '获取验证码'
    },
    on: {
      "click": function($event) {
        _vm.sendCode()
      }
    }
  }, [_vm._v("\n      " + _vm._s(_vm.verifyMsg) + "\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "coloryellow"
  }, [_vm._v("提交成功后，工作人员会尽快与您联系。")]), _vm._v(" "), _c('div', {
    staticClass: "btn",
    on: {
      "click": function($event) {
        _vm.submit()
      }
    }
  }, [_vm._v("立即申请")])]) : _vm._e(), _vm._v(" "), (_vm.showSuccess) ? _c('img', {
    staticStyle: {
      "margin": "20px 0 30px 0"
    },
    attrs: {
      "id": "isSuccess",
      "src": require("./2.png"),
      "width": "100%",
      "height": "40%",
      "alt": ""
    }
  }) : _vm._e(), _vm._v(" "), _vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), (!_vm.showSuccess) ? _c('div', {
    staticClass: "topdiv"
  }, [_c('button', {
    staticClass: "backtop",
    on: {
      "click": function($event) {
        _vm.backTop()
      }
    }
  }, [_vm._v("立即申请")])]) : _vm._e(), _vm._v(" "), _vm._m(2), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('alert', {
    attrs: {
      "showModal": _vm.showAlert
    },
    on: {
      "update:showModal": function($event) {
        _vm.showAlert = $event
      }
    }
  }, [_vm._v(_vm._s(_vm.alertMessage))])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "firstInput"
  }, [_c('div', {
    staticClass: "topImg"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("重磅福利")])]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "fee"
  }, [_c('div', {
    staticClass: "spanTitle"
  }, [_c('span', {
    staticStyle: {
      "margin-left": "0px"
    }
  }, [_vm._v("优惠手续费率")])]), _vm._v(" "), _c('div', {
    staticClass: "spanContent"
  }, [_c('span', [_vm._v("新开户即享优惠手续费率")])])]), _vm._v(" "), _c('div', {
    staticClass: "fancyNumber"
  }, [_c('div', {
    staticClass: "spanTitleTwo"
  }, [_c('span', {
    staticStyle: {
      "margin-left": "0px"
    }
  }, [_vm._v("免费期货靓号")])]), _vm._v(" "), _c('div', {
    staticClass: "spanContent"
  }, [_c('span', [_vm._v("如尾号「666」、「888」等靓号数量有限，先到先得!")])]), _vm._v(" "), _c('div', {
    staticClass: "spanStyle"
  }, [_c('span', [_vm._v("(温馨提示:请在提交资料后7日内完成开户哦)")])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "firstInputOne"
  }, [_c('div', {
    staticClass: "topImg"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("公司背景")])]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "threeFee"
  }, [_c('div', {
    staticClass: "imgDiv"
  }, [_c('img', {
    attrs: {
      "src": require("./company.png"),
      "width": "100%",
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "textSpan"
  }, [_vm._v("东航期货成立于1995年，总部设于上海")])]), _vm._v(" "), _c('div', {
    staticClass: "threeFee"
  }, [_c('div', {
    staticClass: "imgDiv"
  }, [_c('img', {
    attrs: {
      "src": require("./service.png"),
      "width": "100%",
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "textSpan"
  }, [_vm._v("专注提供期货开户，行情交易服务")])]), _vm._v(" "), _c('div', {
    staticClass: "threeFee"
  }, [_c('div', {
    staticClass: "imgDiv"
  }, [_c('img', {
    attrs: {
      "src": require("./sponsor.png"),
      "width": "100%",
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "textSpan"
  }, [_vm._v("国内知名期货实盘大赛“蓝海密剑”主办方")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bottomBanner"
  }, [_c('span', {
    staticStyle: {
      "margin-top": "20px",
      "color": "rgb(255, 220, 99)",
      "margin-left": "0px",
      "font-size": "14px"
    }
  }, [_vm._v("从事证券投资或期货交易，请通过合法证券期货经营机构进行。合法机构名单可到中国证监会网站(www.csrc.gov.cn)查询。")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "margin-top": "20px",
      "color": "#fff",
      "font-size": "14px"
    }
  }, [_vm._v("———— 交易有风险 入市需谨慎 ————")]), _vm._v(" "), _c('img', {
    staticStyle: {
      "margin-top": "20px"
    },
    attrs: {
      "src": require("./dhqhLogo.png"),
      "width": "120px",
      "height": "30px",
      "alt": ""
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "Statement"
  }, [_c('span', {
    staticStyle: {
      "color": "#fff",
      "display": "inline-block",
      "font-size": "14px"
    }
  }, [_vm._v("东航期货有限责任公司版权所有")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "margin-top": "5px",
      "margin-bottom": "20px",
      "color": "#fff",
      "display": "inline-block",
      "font-size": "14px"
    }
  }, [_vm._v("经营证券期货业务许可证编号:000000061878")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-bc405704"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/lhsx/index.vue
// module id = 909
// module chunks = 2